import styled from '@emotion/styled';

export const Container = styled.div`
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 32px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 20px 0;
`;

export const MetricsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
`;

export const MetricCard = styled.div`
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    border-radius: 8px;
    padding: 20px;
    color: #ffffff;
`;

export const MetricLabel = styled.div`
    font-size: 13px;
    font-weight: 500;
    opacity: 0.9;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const MetricValue = styled.div`
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 4px;
`;

export const MetricSubtext = styled.div`
    font-size: 13px;
    opacity: 0.8;
`;

export const TierProgressSection = styled.div`
    margin-bottom: 24px;
`;

export const TierProgressLabel = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 8px;
`;

export const ProgressBarContainer = styled.div`
    width: 100%;
    height: 24px;
    background: #e5e7eb;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    margin-bottom: 8px;
`;

export const ProgressBar = styled.div<{ progress: number }>`
    height: 100%;
    width: ${(props) => props.progress}%;
    background: linear-gradient(90deg, #10b981 0%, #059669 100%);
    border-radius: 12px;
    transition: width 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 12px;
`;

export const ProgressText = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
`;

export const TierInfoText = styled.div`
    font-size: 13px;
    color: #6b7280;
    margin-bottom: 16px;
`;

export const TierBreakdownTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-top: 8px;
`;

export const TableHeader = styled.thead`
    background: #f9fafb;
`;

export const TableHeaderCell = styled.th`
    padding: 12px;
    text-align: left;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    border-bottom: 2px solid #e5e7eb;
`;

export const TableRow = styled.tr<{ highlighted?: boolean }>`
    background: ${(props) => (props.highlighted ? '#eff6ff' : '#ffffff')};
    border-bottom: 1px solid #e5e7eb;
`;

export const TableCell = styled.td`
    padding: 12px;
    font-size: 14px;
    color: #6b7280;
`;

export const TierBadge = styled.span`
    display: inline-block;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    background: #e0e7ff;
    color: #3730a3;
`;

export const FeeAmount = styled.span<{ highlighted?: boolean }>`
    font-weight: ${(props) => (props.highlighted ? '700' : '500')};
    color: ${(props) => (props.highlighted ? '#6366f1' : '#6b7280')};
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #6b7280;
`;

export const EmptyStateText = styled.p`
    font-size: 14px;
    margin: 0;
`;
